var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHome = function SvgHome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 22.5V14.8425C26.25 13.0737 26.25 12.1894 25.899 11.4076C25.5479 10.6259 24.8869 10.0384 23.5649 8.86326L20.3149 5.97437C17.7855 3.726 16.5208 2.60182 15 2.60182C13.4792 2.60182 12.2145 3.726 9.6851 5.97436L9.68509 5.97436L6.43509 8.86325L6.43508 8.86326C5.11308 10.0384 4.45208 10.6259 4.10104 11.4076C3.75 12.1894 3.75 13.0737 3.75 14.8425V22.5C3.75 24.1437 3.75 24.9656 4.20398 25.5188C4.28709 25.6201 4.37995 25.7129 4.48121 25.796C5.03439 26.25 5.85626 26.25 7.5 26.25H7.91667C9.16282 26.25 9.7859 26.25 10.25 25.982C10.554 25.8065 10.8065 25.554 10.9821 25.25C11.25 24.7859 11.25 24.1628 11.25 22.9167V20C11.25 17.9289 12.9289 16.25 15 16.25C17.0711 16.25 18.75 17.9289 18.75 20V22.9167C18.75 24.1628 18.75 24.7859 19.0179 25.25C19.1935 25.554 19.446 25.8065 19.75 25.982C20.2141 26.25 20.8372 26.25 22.0833 26.25H22.5C24.1437 26.25 24.9656 26.25 25.5188 25.796C25.6201 25.7129 25.7129 25.6201 25.796 25.5188C26.25 24.9656 26.25 24.1437 26.25 22.5Z",
    fill: "#F66761"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Home.78435814.svg";
export { ForwardRef as ReactComponent };